.tab-button {
  appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  padding: 0;
}

.tab-list {
  position: relative;
  box-sizing: border-box;
}
